import {getRequirementsFromCourse} from 'constants/url';
import useLoad from '../../../components/hooks/useLoad';

function useLoadRequirementById(id: number) {
  return useLoad(
    getRequirementsFromCourse,
    ['iD_Course', 'iD_Profile', 'iD_Sector'],
    {id},
  );
}

export default useLoadRequirementById;
